"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CChannelPoints2 = void 0;
const POINT2_1 = require("../JavaLineArray/POINT2");
/**
 * A class for channel points used by clsChannelUtility
 *
 */
class CChannelPoints2 {
    m_Line1;
    m_Line2;
    constructor(...args) {
        switch (args.length) {
            case 0: {
                this.m_Line1 = new POINT2_1.POINT2();
                this.m_Line2 = new POINT2_1.POINT2();
                break;
            }
            case 1: {
                const [pts] = args;
                this.m_Line1 = new POINT2_1.POINT2(pts.m_Line1);
                this.m_Line2 = new POINT2_1.POINT2(pts.m_Line2);
                break;
            }
            default: {
                throw Error(`Invalid number of arguments`);
            }
        }
    }
}
exports.CChannelPoints2 = CChannelPoints2;
//# sourceMappingURL=CChannelPoints2.js.map